<script lang="ts" setup>
import { getEditorialCategories, type GetEditorialContentsEditorialCategoryResponse, getEditorialConfiguration } from '@/api';
import { useI18n } from 'vue-i18n';
import { onMounted, ref } from 'vue';
import SectionHeader from '@/components/SectionHeader.vue';
import EditorialCategoryCardHorizontal from '@/views/editorial/EditorialCategoryCardHorizontal.vue';

const { t } = useI18n();

const fetchEditorialCategories = async (): Promise<GetEditorialContentsEditorialCategoryResponse[]> => {
  const configurationResult = await getEditorialConfiguration();
  if (!configurationResult.response?.ok || !configurationResult.data) throw new Error(`Failed to fetch editorial configuration. ${JSON.stringify(configurationResult.error)}`);

  const configuration = configurationResult.data;

  const categoriesResult = await getEditorialCategories();
  if (!categoriesResult.response?.ok || !categoriesResult.data) throw new Error(`Failed to fetch editorial categories. ${JSON.stringify(categoriesResult.error)}`);

  return configuration.homeRandomized ? categoriesResult.data.items.sort(() => 0.5 - Math.random()) : categoriesResult.data.items;
};

const editorialCategories = ref<GetEditorialContentsEditorialCategoryResponse[]>([]);

const loadCategories = async () => {
  try {
    editorialCategories.value = await fetchEditorialCategories();
  } catch (error) {
    console.error('Error loading editorial categories:', error);
  }
};

onMounted(() => {
  loadCategories();
});
</script>

<template>
  <article class="mb-6">
    <SectionHeader>{{ t('views.editorial.header') }}</SectionHeader>

    <div v-if="editorialCategories.length > 0" class="grid grid-cols-1 gap-4 md:grid-cols-2">
      <EditorialCategoryCardHorizontal v-for="category in editorialCategories" :key="category.id" :category="category" />
    </div>

    <div v-else class="py-12 text-center">
      <p class="text-gray-500">{{ t('views.editorial.no-categories') }}</p>
    </div>
  </article>
</template>

<style lang="css" scoped></style>
